import React from "react";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Socials from "./components/Socials";
import "./index.css";

export default function App() {
  return (
    <>
      {/* Page content */}
      <Navbar />
      <div className="min-h-screen bg-gradient-to-b from-white to-gray-100 text-gray-900 flex flex-col items-center px-4 py-10 md:py-20 pt-20 relative z-10">
        <div className="w-full max-w-5xl space-y-20">
          <Home id="home" />
          <Projects id="projects" />
          <Skills id="skills" />
          <Socials id={"socials"}/>
        </div>
      </div>
    </>
  );
}
